// src/hooks/useCritsEnabled.js
// ============================================================================
// Client mirror of functions/modules/economy.js (evergreen step 2.3).
// settings/economy.critsEnabled hides the Crit economy behind one flag:
// default TRUE (missing doc, missing field, or a read error keep everything
// as it is today), only an explicit `false` hides it. Per-feature onSnapshot
// so a flip in a no-events window lands on every open tab within seconds and
// a rollback write is just as immediate. settings/* is world-readable.
// ============================================================================

import { useEffect, useState } from 'react';
import { doc, onSnapshot } from 'firebase/firestore';
import { db } from '../../firebaseConfig';

export default function useCritsEnabled() {
  const [enabled, setEnabled] = useState(true);
  useEffect(() => {
    const unsub = onSnapshot(
      doc(db, 'settings', 'economy'),
      (snap) => setEnabled(!(snap.exists() && snap.data()?.critsEnabled === false)),
      () => setEnabled(true)
    );
    return () => unsub();
  }, []);
  return enabled;
}

// Same flag, opposite default, for PUBLIC copy (the signed-out Landing page):
// false until the first snapshot confirms Crits are on, and false on a read
// error. After the wind-down the Crit pitch would be untrue, so a slow or
// blocked read must never show it; the in-app callers above keep the
// fail-open default.
export function useCritsConfirmedOn() {
  const [on, setOn] = useState(false);
  useEffect(() => {
    const unsub = onSnapshot(
      doc(db, 'settings', 'economy'),
      // A missing doc counts as "on" only when the SERVER says so: offline or
      // blocked, the SDK raises an empty snapshot from cache (fromCache), and
      // that must not flip the page to the Crit pitch.
      (snap) => setOn(snap.exists() ? snap.data()?.critsEnabled !== false : !snap.metadata?.fromCache),
      () => setOn(false)
    );
    return () => unsub();
  }, []);
  return on;
}
